import LegalEntityFormFields from './LegalEntityFormFields';

export default LegalEntityFormFields;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/search-watch-list-entries-form/legal-entity-form-fields/index.js